import { Text, mergeClasses } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { useInfoRowStyles } from './InfoRow.styles';

export interface InfoRowProps {
  label: string;
  value?: string | null;
  href?: string;
  testId?: string;
  layout?: 'stacked' | 'inline';
}

export const InfoRow = ({ label, value, href, testId, layout = 'stacked' }: InfoRowProps) => {
  const styles = useInfoRowStyles();
  const { t } = useTranslation('eventDetails');

  const hasValue = value !== undefined && value !== null && value !== '';

  return (
    <div className={layout === 'inline' ? styles.rootInline : styles.root} data-testid={testId}>
      <Text className={styles.label}>{label}</Text>
      {hasValue ? (
        href ? (
          <a className={styles.link} href={href}>
            {value}
          </a>
        ) : (
          <Text className={styles.value}>{value}</Text>
        )
      ) : (
        <Text className={mergeClasses(styles.value, styles.notProvided)}>{t('notProvided')}</Text>
      )}
    </div>
  );
};

InfoRow.displayName = 'InfoRow';
